<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 40px;">
            <div class="w-full flex justify-end">
                <i-select v-model="modulo" clearable @on-change="getFuncao(modulo)" placeholder="Modulo" class="w-64 ml-2">
                    <Option v-for="item in modulos" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="funcao" v-if="modulo!=null" clearable @on-change="getFuncionalidade(funcao)" placeholder="Função" class="w-64 ml-2">
                    <Option v-for="item in funcoes" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="funcionalidade" v-if="funcao!=null && modulo!=null" clearable @on-change="filterData" placeholder="Funcionalidade" class="w-64 ml-2">
                    <Option v-for="item in funcionalidades" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="analista" clearable @on-change="filterData" placeholder="Analista" class="w-64 ml-2">
                    <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <InputNumber :active-change="false" :max="36" :min="1" v-model="periodo" class="ml-2"></InputNumber>
                <i-switch @on-change="getStats" false-value="mensal" size="large" class="m-2"
                            true-value="semanal" v-model="formato">
                    <span slot="open">SEM</span>
                    <span slot="close">MEN</span>
                </i-switch>
            </div>
        </Row>
        <BarChart
                v-if="show_graphs"
                :options="chartData"
                @click="getDetails"
        />
        <Spin size="large" fix v-if="carregar"></Spin>
        <TicketsTable :csv="csv" :analistas="analistas" :relatores="tickets_pessoas" :loading="carregar_tabela"
                      :tickets="tickets" v-if="showTable" :exibir-projeto="false" exibir-detalhes ocultar-finalizados exibir-incidentes></TicketsTable>
        <DrawerTicket v-model="edit_pgd" :id="edit_id"></DrawerTicket>
    </div>
</template>

<script>

    const {moment, toQueryString} = require("../../../helpers/utils.js");
    const _ = require("lodash");
    export default {
        name: "EstatisticasIncidentes",
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
            DrawerTicket: () => import("./Drawer.vue")
        },
        data:()=>({
            csv: false,
            exibirProjeto: false,
            analista: null,
            modulo:null,
            modulos:[],
            funcao:null,
            funcoes:[],
            funcionalidade:null,
            funcionalidades:[],
            carregar: false,
            carregar_tabela: false,
            formato: 'semanal',
            periodo: 6,
            chartData: {},
            show_graphs:true,
            showTable: false,
            tickets: [],
            stats_data: [],
            edit_pgd: false,
            edit_id: 0,
        }),
        methods: {
            /**
             * Filtra os dados por analista
             */
            filterData() {
                let stats = this.stats_data;
                this.fillData([
                    stats.map((tl) => this.getFilter(tl.bug).reduce((accum, curr) => accum + parseInt(curr.erros), 0)), // Bugs
                    stats.map((tl) => this.getFilter(tl.mel).reduce((accum, curr) => accum + parseInt(curr.erros), 0)), // Mel
                    stats.map((tl) => this.getFilter(tl.ss).reduce((accum, curr) => accum + parseInt(curr.erros), 0)), // SS
                    stats.map((tl) => this.getFilter(tl.mvp).reduce((accum, curr) => accum + parseInt(curr.erros), 0)), // MVP
                ], [
                    stats.map((tl) => this.getFilter(tl.bug).length), // Bugs 
                    stats.map((tl) => this.getFilter(tl.mel).length), // Mel 
                    stats.map((tl) => this.getFilter(tl.ss).length), // SS 
                    stats.map((tl) => this.getFilter(tl.mvp).length), // MVP 
                ]);
            },

            /**
             * Preenche o objeto que é usado pelo gráfico
             */
            fillData([
                 bug,
                 mel,
                 ss,
                 mvp,
             ],
             tickets) {

                const total = bug.map((item, idx) => item + mel[idx] + ss[idx] + mvp[idx]);

                let itemStyle = {
                    normal: {
                        barBorderWidth: "0",
                        barBorderColor: "#444444"
                    },
                    emphasis: {
                        barBorderWidth: "0",
                        barBorderColor: "#444444"
                    }
                };

                const labelTop = {
                    normal: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value ? Math.abs(param.value) : '',
                    }
                };

                this.chartData = {
                    backgroundColor: '#fff',
                    legend: {},
                    tooltip: {
                        type:'shadow',
                        formatter:(params)=>{
                            if (params.seriesType === "line") {
                                return params.seriesName + "<br />" + params.marker + ' ' + params.name + ': ' + Math.abs(params.value);
                            }
                            return `
                                <span>${params.marker} ${params.seriesName}</span><br>
                                <span>Erros: ${params.value}</span><br>
                                <span>Tickets: ${tickets[params.seriesIndex][params.dataIndex]}</span><br>
                            `  
                        }
                    },
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    series: [
                        {
                            name: 'Bugs',
                            type: 'bar',
                            stack: 'bug',
                            color: '#ff1744',
                            data: bug,
                            label: labelTop,
                        },
                        {
                            name: 'Melhorias',
                            type: 'bar',
                            stack: 'mel',
                            color: '#009688',
                            data: mel,
                            label: labelTop,
                        },
                        {
                            name: 'SS',
                            type: 'bar',
                            stack: 'ss',
                            color: '#2196f3',
                            data: ss,
                            label: labelTop,
                        },
                        {
                            name: 'MVP',
                            type: 'bar',
                            stack: 'mvp',
                            color: '#3f51b5',
                            data: mvp,
                            label: labelTop,
                        },
                        {
                            name: 'Total',
                            type: 'line',
                            color: '#607d8b',
                            data: total,
                            label: labelTop,
                        },
                    ]
                };
            },

            getFilter(dados){
                const analista = this.analista
                const modulo = this.modulo
                const funcao = this.funcao
                const funcionalidade = this.funcionalidade
                return dados.filter((item) => {
                    // verifica os filtros ativos
                    if (analista && modulo && funcao && funcionalidade) {
                        return analista == item.atribuido_a_id && modulo == item.modulo && funcao == item.funcao && funcionalidade == item.funcionalidade
                    }
                    if (analista && modulo && funcao) {
                        return analista == item.atribuido_a_id && modulo == item.modulo && funcao == item.funcao
                    }
                    if (analista && modulo) {
                        return analista == item.atribuido_a_id && modulo == item.modulo
                    }
                    if (analista) {
                        return analista == item.atribuido_a_id
                    }
                    if (modulo && funcao && funcionalidade) {
                        return modulo == item.modulo && funcao == item.funcao && funcionalidade == item.funcionalidade
                    }
                    if (modulo && funcao) {
                        return modulo == item.modulo && funcao == item.funcao
                    }
                    if (modulo) {
                        return modulo == item.modulo
                    }
                    return item
                })   
            },
            getLegenda(size) {
                let legenda = [];
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"];
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`;
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY");
                    }
                }
                return legenda.reverse();
            },

            async getStats() {
                this.showTable = false;
                this.carregar = true;
                const URI = `ticket/estatisticas/incidentes?formato=${this.formato}&periodo=${this.periodo}`;
                const {data} = await this.$axios.get(URI);
                this.stats_data = data.reverse();

                this.legenda = this.getLegenda(data.length);
                this.filterData();
                this.carregar = false;
            },

            /**
             * Ao clicar em uma barra do chart, é chamado este método que trás os detalhes da Timeline
             */
            getDetails(params) {
                this.showTable = true;
                this.carregar_tabela = true;
                if (!params.selected) {
                    this.tickets = [];
                    this.$emit('download', this.showTable);
                } else {
                    this.showTable = false;
                    this.$emit('download', this.showTable);
                    return;
                }

                this.exibirProjeto = params.seriesName.toLowerCase().includes('mvp');

                const dataIndex = params.dataIndex;
                const seriesIndex = params.seriesIndex;
                const options = ['bug', 'mel', 'ss', 'mvp' ];
                const option = options[seriesIndex];
                let ids = [];
                if (seriesIndex != 5) {
                    ids = this.stats_data[dataIndex][option].filter(item => this.analista ? this.analista == item.atribuido_a_id : item).map(item => item.id_ticket);
                } else {
                    const ticketsTypes = this.stats_data[dataIndex];
                    ids = [...ticketsTypes['bug'], ...ticketsTypes['mvp'], ...ticketsTypes['mel'], ...ticketsTypes['ss']].filter(item => this.analista ? this.analista == item.atribuido_a_id : item).map(item => item.id_ticket);;
                }

                const URI = `ticket/estatisticas/incidentes/detalhe?${toQueryString({
                    ids,
                })}`;

                this.$axios.get(URI).then(({data}) => {
                    this.tickets = data.data.map(item => {
                        item.solicitantes = item.solicitantes
                            ? JSON.parse(item.solicitantes)
                            : [];
                        return item;
                    });
                    this.carregar_tabela = false;
                    this.$emit('download', this.showTable);
                }).catch(err => {
                    console.warn(err);
                    this.showTable = false;
                    this.carregar_tabela = false;
                });
            },

            /**
             * Abre o drawer para edição do ticket
             */
            editTicket(id_ticket) {
                this.edit_id = id_ticket;
                this.edit_pgd = true;
            },

            async getModulos(){
                let modulos = await this.getChildren(1)
                this.modulos = _.orderBy(modulos, ['label'],['asc'])
            },

            async getFuncao(id){
                let funcoes = await this.getChildren(id)
                this.funcoes = _.orderBy(funcoes, ['label'],['asc'])
                this.filterData()
            },

            async getFuncionalidade(id){
                let funcionalidades = await this.getChildren(id)
                this.funcionalidades = _.orderBy(funcionalidades, ['label'],['asc'])
                this.filterData()
            },

            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`);
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }));
            },
        },
        computed: {
            tickets_pessoas() {
                let pesssoas = this.$store.getters['usuarios']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                return _.orderBy(pesssoas, ['label'],['asc'])
            },
            analistas() {
                let analistas = this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }))
                return _.orderBy(analistas, ['label'],['asc'])
            },
        },
        created() {
            this.getModulos()
            this.getStats()
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.formato = 'semanal'
                    this.periodo = 12;
                    this.analista = null;
                    this.showTable = false
                    this.getStats()
                }
            },
            download(){
                this.csv=this.download
            },
            close(){
                if (this.close){
                    this.showTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }    
            },
            showTable(){
                this.$emit('download',this.showTable)
            },
            analista(){
                this.showTable = false
            },
            periodo: _.debounce(function () {
                this.showTable = false;
                this.getStats();
            }, 1000),
            modulo(){
                this.funcao = null
                this.funcionalidade = null
            },
            funcao(){
                this.funcionalidade = null
            }
        },
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
    }
</style>
